import cn from 'classnames';
import React, { cloneElement, FunctionComponent } from 'react';

import { intersperse } from 'utils/collections';
import { block } from '../utils';
import NoSearchResultSeparator from './NoSearchResultSeparator';
import NoSearchResultTip from './NoSearchResultTip';
import { useIntegrationsContext } from './PodcastSearchIntegrationsContext';

const NoSearchResult: FunctionComponent = () => {
  const { integrations } = useIntegrationsContext();

  return (
    <div className={block('no-search-result')}>
      <p className={block('no-search-result-title')}>
        No luck. <br /> Did you try one of these:
      </p>
      <div className={block('no-search-result-icons')}>
        {intersperse(
          integrations
            .filter(({ hidden }) => !hidden)
            .map(({ color, icon, id, tip }) => (
              <NoSearchResultTip
                color={color}
                icon={cloneElement(icon, {
                  className: cn(
                    icon.props.className,
                    block('no-results-icon', { [id]: true }),
                  ),
                })}
                key={id}
              >
                {tip}
              </NoSearchResultTip>
            )),
          (_, index) => (
            <NoSearchResultSeparator
              key={`${integrations[index].id}-separator`}
            />
          ),
        )}
      </div>

      <div className={block('no-search-result-support-line')}>
        <span>
          Still not seeing it? <br />
          Get help{' '}
          <a
            href="https://learn.headliner.app/hc/en-us/articles/1500005166802-How-do-I-add-my-podcast-to-Headliner-s-podcast-search"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          .
        </span>
      </div>
    </div>
  );
};

export default NoSearchResult;
